export default {
  flagReview: {
    form: {
      buttonText: 'Submit',
    },
  },
};
